module.exports = __webpack_public_path__ + "static/media/29.146d8432.jpg";